import { Injectable } from '@angular/core';

import { ActivitySessionService } from './activity-session.service';
import { DispatcherEventFactoryService } from './dispatcher-instrumentation.service';
import { InstrumentationEvent, InstrumentationParams, KnownInstrumentationEvents } from './instrumentation.service';

class ActivityTrackingEvent implements InstrumentationEvent {

    constructor(
        private readonly activitySessionService: ActivitySessionService,
        private readonly streamName: string,
        public params: InstrumentationParams,
        public metrics: Array<string>
    ) {
    }

    public record(): void {
        if (this.streamName === KnownInstrumentationEvents.GenericClick) {
            this.activitySessionService.incrementClick();
        }
    }
}

/**
 * Factory that is responsible for creating activity tracking event instances
 */
@Injectable({
    providedIn: 'root'
})
export class ActivityEventFactoryService implements DispatcherEventFactoryService {

    constructor(
        private readonly activitySessionService: ActivitySessionService
    ) {
    }

    public createEvent(
        streamName: string,
        params: InstrumentationParams,
        metrics: Array<string>): InstrumentationEvent {

        return new ActivityTrackingEvent(this.activitySessionService, streamName, params, metrics);
    }

    public flush() {
        // Do nothing, flushing is not supported.
    }
}
